module.exports = __webpack_public_path__ + "img/EXPLICA.4258c5d5.png";